import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    width: 550,
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  line: {
    width: '60%',
    margin: 'auto',
    marginTop: 16,
    marginBottom: 16,
  },
}))

export default useStyles
